/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material';

import { StackableToast } from './StackableToast';
import type { NotificationStack, NotificationType } from './types';

interface NotificationContainerProps {
  stacks: Partial<Record<NotificationType, NotificationStack>>;
  onNavigate: (type: NotificationType, direction: 'prev' | 'next') => void;
  onRemoveMessage: (type: NotificationType, messageId: string) => void;
  onCloseStack: (type: NotificationType) => void;
}

export function NotificationContainer({
  stacks,
  onNavigate,
  onRemoveMessage,
  onCloseStack,
}: NotificationContainerProps) {
  const stacksArray = Object.entries(stacks);

  if (stacksArray.length === 0) {
    return null;
  }

  return (
    <Box
      id="notification-snackbar"
      sx={{
        position: 'fixed',
        top: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        pointerEvents: 'none',
        '& > *': {
          pointerEvents: 'auto',
        },
      }}
    >
      {stacksArray.map(([type, stack]) => {
        if (!stack) return null;
        return (
          <StackableToast
            key={type}
            stack={stack}
            onNavigate={(direction) => onNavigate(type as NotificationType, direction)}
            onRemoveMessage={(messageId) => onRemoveMessage(type as NotificationType, messageId)}
            onCloseStack={() => onCloseStack(type as NotificationType)}
          />
        );
      })}
    </Box>
  );
}
